"use client";

import React from "react";
import { useRef, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import aboutUs from "../../../assets/LandingPage/aboutus.png";
import Vector from "../../../assets/LandingPage/Vector.png";
import Olena from "../../../assets/LandingPage/newLandingPage/team/Olena.png";
import Alan from "../../../assets/LandingPage/newLandingPage/team/Alan.jpeg";
import Bosun from "../../../assets/LandingPage/newLandingPage/team/Bosun.jpeg";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export default function About() {
  const sectionsRef = useRef([]);
  const isMobile = window.innerWidth < 768;


const scrollToSection = (id) => {
  gsap.to(window, {
    scrollTo: {
      y: `#${id}`, // ✅ use ID as a string
      offsetY: 60, // optional offset from top
    },
    duration: 1.5,
    ease: "power2.inOut",
  });
};

  // Helper to add refs
  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    // Page load animation (fade + slide in)
    gsap.fromTo(
      ".page-wrapper",
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1.2, ease: "power3.out" }
    );

    // Section scroll animations
    sectionsRef.current.forEach((section, i) => {
      gsap.fromTo(
        section,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);
  const openPositions = [
    {
      title: "Head of Design",
      department: "Design",
      location: "San Francisco, CA / Remote",
      link: "https://wellfound.com/jobs/3400689-head-of-design-sourceiq",
    },

    {
      title: "Sales Development Representative (SDR) Intern",
      department: "Sales",
      location: "San Francisco, CA / Remote",
      link: "https://wellfound.com/jobs/3401876-sales-development-representative-sdr-intern",
    },
  ];
  return (
    <>
      <Header />
      <div className="flex flex-col w-full overflow-hidden bg-white">
        <section
          ref={addToRefs}
          className="relative w-full flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-36 sm:py-12 bg-[#F0FBFF]"
        >
          <div className="relative z-10 max-w-2xl text-left mx-auto md:mx-0">
            {/* Badge */}
            <div className="inline-flex justify-start items-center gap-2 rounded-full px-4 py-2 w-fit bg-blue-500/10 mb-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H1ZM7 18C6.71667 18 6.47917 17.9042 6.2875 17.7125C6.09583 17.5208 6 17.2833 6 17V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18H7ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V17C24 17.2833 23.9042 17.5208 23.7125 17.7125C23.5208 17.9042 23.2833 18 23 18H19.5ZM8.125 16H15.9C15.7333 15.6667 15.2708 15.375 14.5125 15.125C13.7542 14.875 12.9167 14.75 12 14.75C11.0833 14.75 10.2458 14.875 9.4875 15.125C8.72917 15.375 8.275 15.6667 8.125 16ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12ZM12 10C12.2833 10 12.5208 9.90417 12.7125 9.7125C12.9042 9.52083 13 9.28333 13 9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8C11.7167 8 11.4792 8.09583 11.2875 8.2875C11.0958 8.47917 11 8.71667 11 9C11 9.28333 11.0958 9.52083 11.2875 9.7125C11.4792 9.90417 11.7167 10 12 10Z"
                  fill="#0088FF"
                />
              </svg>
              <span className="text-[#0088FF] text-base">Our Company</span>
            </div>

            {/* Heading */}
            <h2 className="text-4xl md:text-6xl font-bold text-[#08F] mb-6">
              About Us
            </h2>

            {/* Paragraph */}
            <p className="text-[#08F] text-3xl leading-relaxed mb-10">
              We’re transforming how organizations source, evaluate, and engage
              vendors through AI-powered automation and cloud-native
              infrastructure.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
              onClick={() => scrollToSection('mission')}
              className="bg-[#0088FF] text-white px-6 py-2 rounded transition flex flex-row gap-2 items-center">
                Read About Our Mission
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.5192 11.1362C17.1807 11.5221 17.1807 12.4779 16.5192 12.8638L7.50387 18.1227C6.83721 18.5116 6 18.0308 6 17.259L6 6.74104C6 5.96925 6.83721 5.48838 7.50387 5.87726L16.5192 11.1362Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button
             onClick={() =>
              window.open(
                "https://wellfound.com/company/sourceiqtalkdei/jobs",
                "_blank"
              )}
              className="border border-[#0088FF] text-[#0088FF] px-6 py-2 rounded hover:bg-[#EAF3FF] transition">
                Careers
              </button>
            </div>
          </div>

          {/* Right image placeholder */}
          <div className="relative z-10 mt-12 md:mt-0 h-[500px] sm:h-[700px]">
            <img src={aboutUs} width={466} alt=""></img>
          </div>
        </section>

        {/* === MISSION SECTION === */}
        <section
          ref={addToRefs}
          id="mission"
          className="relative text-center px-6 md:px-16 lg:px-24 py-24 bg-white"
          style={
            isMobile
              ? {
                  backgroundImage: `url(${Vector})`,
                  backgroundRepeat: "repeat",
                  backgroundSize: "contain",
                }
              : {}
          }
        >
          {/* Desktop background image */}
          {!isMobile && (
            <img
              src={Vector}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover -z-10"
            />
          )}
          <div className="inline-flex justify-start items-center gap-1 rounded-full px-4 py-2 w-fit bg-lightblue mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.975 18.2502C7.80833 17.7669 7.65417 17.2752 7.5125 16.7752C7.37083 16.2752 7.25833 15.7752 7.175 15.2752L6 16.0752V19.0502L7.975 18.2502ZM11.65 4.8752C10.85 5.7252 10.2083 6.84603 9.725 8.2377C9.24167 9.62936 9 11.0919 9 12.6252C9 13.6252 9.09167 14.6044 9.275 15.5627C9.45833 16.521 9.7 17.3335 10 18.0002H14C14.3 17.3335 14.5417 16.521 14.725 15.5627C14.9083 14.6044 15 13.6252 15 12.6252C15 11.0919 14.7583 9.62936 14.275 8.2377C13.7917 6.84603 13.15 5.7252 12.35 4.8752C12.3 4.8252 12.2458 4.7877 12.1875 4.7627C12.1292 4.7377 12.0667 4.7252 12 4.7252C11.9333 4.7252 11.8708 4.7377 11.8125 4.7627C11.7542 4.7877 11.7 4.8252 11.65 4.8752ZM12 13.0002C11.45 13.0002 10.9792 12.8044 10.5875 12.4127C10.1958 12.021 10 11.5502 10 11.0002C10 10.4502 10.1958 9.97936 10.5875 9.5877C10.9792 9.19603 11.45 9.0002 12 9.0002C12.55 9.0002 13.0208 9.19603 13.4125 9.5877C13.8042 9.97936 14 10.4502 14 11.0002C14 11.5502 13.8042 12.021 13.4125 12.4127C13.0208 12.8044 12.55 13.0002 12 13.0002ZM16.025 18.2502L18 19.0502V16.0752L16.825 15.2752C16.7417 15.7752 16.6292 16.2752 16.4875 16.7752C16.3458 17.2752 16.1917 17.7669 16.025 18.2502ZM12.775 2.6002C14.175 3.8002 15.2292 5.2752 15.9375 7.0252C16.6458 8.7752 17 10.7669 17 13.0002L19.1 14.4002C19.3833 14.5835 19.6042 14.8252 19.7625 15.1252C19.9208 15.4252 20 15.7419 20 16.0752V20.5252C20 20.8752 19.8542 21.1502 19.5625 21.3502C19.2708 21.5502 18.9583 21.5835 18.625 21.4502L15.025 20.0002H8.975L5.375 21.4502C5.04167 21.5835 4.72917 21.5502 4.4375 21.3502C4.14583 21.1502 4 20.8752 4 20.5252V16.0752C4 15.7419 4.07917 15.4252 4.2375 15.1252C4.39583 14.8252 4.61667 14.5835 4.9 14.4002L7 13.0002C7 10.7669 7.35417 8.7752 8.0625 7.0252C8.77083 5.2752 9.825 3.8002 11.225 2.6002C11.3417 2.51686 11.4667 2.4502 11.6 2.4002C11.7333 2.3502 11.8667 2.3252 12 2.3252C12.1333 2.3252 12.2667 2.3502 12.4 2.4002C12.5333 2.4502 12.6583 2.51686 12.775 2.6002Z"
                fill="#0088FF"
              />
            </svg>
            <span className="text-[#0088FF] text-base">Mission</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Our{" "}
            <span className="bg-gradient-to-r from-[#0088FF] to-[#6583BA] bg-clip-text text-transparent font-hanken font-bold">
              Mission
            </span>
          </h2>
          <p className="text-[#545454] max-w-4xl mx-auto mb-12 text-3xl">
            To bring innovation, inclusion, and intelligence to procurement
            teams ready to move beyond spreadsheets and outdated systems.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M20 18.3333C20.9167 18.3333 21.7014 18.0069 22.3542 17.3542C23.0069 16.7014 23.3333 15.9167 23.3333 15C23.3333 14.0833 23.0069 13.2986 22.3542 12.6458C21.7014 11.9931 20.9167 11.6667 20 11.6667C19.0833 11.6667 18.2986 11.9931 17.6458 12.6458C16.9931 13.2986 16.6667 14.0833 16.6667 15C16.6667 15.9167 16.9931 16.7014 17.6458 17.3542C18.2986 18.0069 19.0833 18.3333 20 18.3333ZM18.3333 31.6667V26.5C16.9722 26.1944 15.7569 25.6181 14.6875 24.7708C13.6181 23.9236 12.8333 22.8611 12.3333 21.5833C10.25 21.3333 8.50694 20.4236 7.10417 18.8542C5.70139 17.2847 5 15.4444 5 13.3333V11.6667C5 10.75 5.32639 9.96528 5.97917 9.3125C6.63194 8.65972 7.41667 8.33333 8.33333 8.33333H11.6667C11.6667 7.41667 11.9931 6.63194 12.6458 5.97917C13.2986 5.32639 14.0833 5 15 5H25C25.9167 5 26.7014 5.32639 27.3542 5.97917C28.0069 6.63194 28.3333 7.41667 28.3333 8.33333H31.6667C32.5833 8.33333 33.3681 8.65972 34.0208 9.3125C34.6736 9.96528 35 10.75 35 11.6667V13.3333C35 15.4444 34.2986 17.2847 32.8958 18.8542C31.4931 20.4236 29.75 21.3333 27.6667 21.5833C27.1667 22.8611 26.3819 23.9236 25.3125 24.7708C24.2431 25.6181 23.0278 26.1944 21.6667 26.5V31.6667H26.6667C27.1389 31.6667 27.5347 31.8264 27.8542 32.1458C28.1736 32.4653 28.3333 32.8611 28.3333 33.3333C28.3333 33.8056 28.1736 34.2014 27.8542 34.5208C27.5347 34.8403 27.1389 35 26.6667 35H13.3333C12.8611 35 12.4653 34.8403 12.1458 34.5208C11.8264 34.2014 11.6667 33.8056 11.6667 33.3333C11.6667 32.8611 11.8264 32.4653 12.1458 32.1458C12.4653 31.8264 12.8611 31.6667 13.3333 31.6667H18.3333ZM11.6667 18V11.6667H8.33333V13.3333C8.33333 14.3889 8.63889 15.3403 9.25 16.1875C9.86111 17.0347 10.6667 17.6389 11.6667 18ZM20 23.3333C21.3889 23.3333 22.5694 22.8472 23.5417 21.875C24.5139 20.9028 25 19.7222 25 18.3333V8.33333H15V18.3333C15 19.7222 15.4861 20.9028 16.4583 21.875C17.4306 22.8472 18.6111 23.3333 20 23.3333ZM28.3333 18C29.3333 17.6389 30.1389 17.0347 30.75 16.1875C31.3611 15.3403 31.6667 14.3889 31.6667 13.3333V11.6667H28.3333V18Z"
                      fill="#0088FF"
                    />
                  </svg>
                ),
                title: "Our Vision",
                text: "A world where every organization can access the best suppliers through intelligent, automated matching and seamless collaboration.",

                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M20 18.3333C20.9167 18.3333 21.7014 18.0069 22.3542 17.3542C23.0069 16.7014 23.3333 15.9167 23.3333 15C23.3333 14.0833 23.0069 13.2986 22.3542 12.6458C21.7014 11.9931 20.9167 11.6667 20 11.6667C19.0833 11.6667 18.2986 11.9931 17.6458 12.6458C16.9931 13.2986 16.6667 14.0833 16.6667 15C16.6667 15.9167 16.9931 16.7014 17.6458 17.3542C18.2986 18.0069 19.0833 18.3333 20 18.3333ZM18.3333 31.6667V26.5C16.9722 26.1944 15.7569 25.6181 14.6875 24.7708C13.6181 23.9236 12.8333 22.8611 12.3333 21.5833C10.25 21.3333 8.50694 20.4236 7.10417 18.8542C5.70139 17.2847 5 15.4444 5 13.3333V11.6667C5 10.75 5.32639 9.96528 5.97917 9.3125C6.63194 8.65972 7.41667 8.33333 8.33333 8.33333H11.6667C11.6667 7.41667 11.9931 6.63194 12.6458 5.97917C13.2986 5.32639 14.0833 5 15 5H25C25.9167 5 26.7014 5.32639 27.3542 5.97917C28.0069 6.63194 28.3333 7.41667 28.3333 8.33333H31.6667C32.5833 8.33333 33.3681 8.65972 34.0208 9.3125C34.6736 9.96528 35 10.75 35 11.6667V13.3333C35 15.4444 34.2986 17.2847 32.8958 18.8542C31.4931 20.4236 29.75 21.3333 27.6667 21.5833C27.1667 22.8611 26.3819 23.9236 25.3125 24.7708C24.2431 25.6181 23.0278 26.1944 21.6667 26.5V31.6667H26.6667C27.1389 31.6667 27.5347 31.8264 27.8542 32.1458C28.1736 32.4653 28.3333 32.8611 28.3333 33.3333C28.3333 33.8056 28.1736 34.2014 27.8542 34.5208C27.5347 34.8403 27.1389 35 26.6667 35H13.3333C12.8611 35 12.4653 34.8403 12.1458 34.5208C11.8264 34.2014 11.6667 33.8056 11.6667 33.3333C11.6667 32.8611 11.8264 32.4653 12.1458 32.1458C12.4653 31.8264 12.8611 31.6667 13.3333 31.6667H18.3333ZM11.6667 18V11.6667H8.33333V13.3333C8.33333 14.3889 8.63889 15.3403 9.25 16.1875C9.86111 17.0347 10.6667 17.6389 11.6667 18ZM20 23.3333C21.3889 23.3333 22.5694 22.8472 23.5417 21.875C24.5139 20.9028 25 19.7222 25 18.3333V8.33333H15V18.3333C15 19.7222 15.4861 20.9028 16.4583 21.875C17.4306 22.8472 18.6111 23.3333 20 23.3333ZM28.3333 18C29.3333 17.6389 30.1389 17.0347 30.75 16.1875C31.3611 15.3403 31.6667 14.3889 31.6667 13.3333V11.6667H28.3333V18Z"
                      fill="#0088FF"
                    />
                  </svg>
                ),
              },
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M20 18.3333C20.9167 18.3333 21.7014 18.0069 22.3542 17.3542C23.0069 16.7014 23.3333 15.9167 23.3333 15C23.3333 14.0833 23.0069 13.2986 22.3542 12.6458C21.7014 11.9931 20.9167 11.6667 20 11.6667C19.0833 11.6667 18.2986 11.9931 17.6458 12.6458C16.9931 13.2986 16.6667 14.0833 16.6667 15C16.6667 15.9167 16.9931 16.7014 17.6458 17.3542C18.2986 18.0069 19.0833 18.3333 20 18.3333ZM18.3333 31.6667V26.5C16.9722 26.1944 15.7569 25.6181 14.6875 24.7708C13.6181 23.9236 12.8333 22.8611 12.3333 21.5833C10.25 21.3333 8.50694 20.4236 7.10417 18.8542C5.70139 17.2847 5 15.4444 5 13.3333V11.6667C5 10.75 5.32639 9.96528 5.97917 9.3125C6.63194 8.65972 7.41667 8.33333 8.33333 8.33333H11.6667C11.6667 7.41667 11.9931 6.63194 12.6458 5.97917C13.2986 5.32639 14.0833 5 15 5H25C25.9167 5 26.7014 5.32639 27.3542 5.97917C28.0069 6.63194 28.3333 7.41667 28.3333 8.33333H31.6667C32.5833 8.33333 33.3681 8.65972 34.0208 9.3125C34.6736 9.96528 35 10.75 35 11.6667V13.3333C35 15.4444 34.2986 17.2847 32.8958 18.8542C31.4931 20.4236 29.75 21.3333 27.6667 21.5833C27.1667 22.8611 26.3819 23.9236 25.3125 24.7708C24.2431 25.6181 23.0278 26.1944 21.6667 26.5V31.6667H26.6667C27.1389 31.6667 27.5347 31.8264 27.8542 32.1458C28.1736 32.4653 28.3333 32.8611 28.3333 33.3333C28.3333 33.8056 28.1736 34.2014 27.8542 34.5208C27.5347 34.8403 27.1389 35 26.6667 35H13.3333C12.8611 35 12.4653 34.8403 12.1458 34.5208C11.8264 34.2014 11.6667 33.8056 11.6667 33.3333C11.6667 32.8611 11.8264 32.4653 12.1458 32.1458C12.4653 31.8264 12.8611 31.6667 13.3333 31.6667H18.3333ZM11.6667 18V11.6667H8.33333V13.3333C8.33333 14.3889 8.63889 15.3403 9.25 16.1875C9.86111 17.0347 10.6667 17.6389 11.6667 18ZM20 23.3333C21.3889 23.3333 22.5694 22.8472 23.5417 21.875C24.5139 20.9028 25 19.7222 25 18.3333V8.33333H15V18.3333C15 19.7222 15.4861 20.9028 16.4583 21.875C17.4306 22.8472 18.6111 23.3333 20 23.3333ZM28.3333 18C29.3333 17.6389 30.1389 17.0347 30.75 16.1875C31.3611 15.3403 31.6667 14.3889 31.6667 13.3333V11.6667H28.3333V18Z"
                      fill="#0088FF"
                    />
                  </svg>
                ),
                title: "Our Values",
                text: "Innovation, transparency, and inclusion drive everything we do. We believe in building technology that empowers people and organizations.",
              },
              {
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M20 36.6668C19.0833 36.6668 18.2986 36.3404 17.6458 35.6877C16.9931 35.0349 16.6667 34.2502 16.6667 33.3335H23.3333C23.3333 34.2502 23.0069 35.0349 22.3542 35.6877C21.7014 36.3404 20.9167 36.6668 20 36.6668ZM15 31.6668C14.5278 31.6668 14.1319 31.5071 13.8125 31.1877C13.4931 30.8682 13.3333 30.4724 13.3333 30.0002C13.3333 29.5279 13.4931 29.1321 13.8125 28.8127C14.1319 28.4932 14.5278 28.3335 15 28.3335H25C25.4722 28.3335 25.8681 28.4932 26.1875 28.8127C26.5069 29.1321 26.6667 29.5279 26.6667 30.0002C26.6667 30.4724 26.5069 30.8682 26.1875 31.1877C25.8681 31.5071 25.4722 31.6668 25 31.6668H15ZM13.75 26.6668C11.8333 25.5279 10.3125 24.0002 9.1875 22.0835C8.0625 20.1668 7.5 18.0835 7.5 15.8335C7.5 12.3613 8.71528 9.40988 11.1458 6.97933C13.5764 4.54877 16.5278 3.3335 20 3.3335C23.4722 3.3335 26.4236 4.54877 28.8542 6.97933C31.2847 9.40988 32.5 12.3613 32.5 15.8335C32.5 18.0835 31.9375 20.1668 30.8125 22.0835C29.6875 24.0002 28.1667 25.5279 26.25 26.6668H13.75ZM14.75 23.3335H25.25C26.5 22.4446 27.4653 21.3474 28.1458 20.0418C28.8264 18.7363 29.1667 17.3335 29.1667 15.8335C29.1667 13.2779 28.2778 11.1113 26.5 9.3335C24.7222 7.55572 22.5556 6.66683 20 6.66683C17.4444 6.66683 15.2778 7.55572 13.5 9.3335C11.7222 11.1113 10.8333 13.2779 10.8333 15.8335C10.8333 17.3335 11.1736 18.7363 11.8542 20.0418C12.5347 21.3474 13.5 22.4446 14.75 23.3335Z"
                      fill="#0088FF"
                    />
                  </svg>
                ),
                title: "Our Approach",
                text: "We combine cutting-edge AI with intuitive design to create solutions that are both powerful and easy to use.",
              },
            ].map((card) => (
              <div
                key={card.title}
                className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 text-center hover:shadow-md transition"
              >
                <div className="mb-4 flex justify-center">{card.icon}</div>
                <h3 className="font-bold text-xl mb-3 text-[#1D2739]">
                  {card.title}
                </h3>
                <p className="text-[#545454] text-base leading-relaxed">
                  {card.text}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* === TEAM SECTION === */}
        <section
          ref={addToRefs}
          className="relative text-center px-6 md:px-16 lg:px-24 py-[82px] bg-white"
          style={
            isMobile
              ? {
                  backgroundImage: `url(${Vector})`,
                  backgroundRepeat: "repeat",
                  backgroundSize: "contain",
                }
              : {}
          }
        >
          {/* Desktop background image */}
          {!isMobile && (
            <img
              src={Vector}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover -z-10"
            />
          )}
          <div className="inline-flex justify-start items-center gap-1 rounded-full px-4 py-2 w-fit bg-lightblue mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.975 18.2502C7.80833 17.7669 7.65417 17.2752 7.5125 16.7752C7.37083 16.2752 7.25833 15.7752 7.175 15.2752L6 16.0752V19.0502L7.975 18.2502ZM11.65 4.8752C10.85 5.7252 10.2083 6.84603 9.725 8.2377C9.24167 9.62936 9 11.0919 9 12.6252C9 13.6252 9.09167 14.6044 9.275 15.5627C9.45833 16.521 9.7 17.3335 10 18.0002H14C14.3 17.3335 14.5417 16.521 14.725 15.5627C14.9083 14.6044 15 13.6252 15 12.6252C15 11.0919 14.7583 9.62936 14.275 8.2377C13.7917 6.84603 13.15 5.7252 12.35 4.8752C12.3 4.8252 12.2458 4.7877 12.1875 4.7627C12.1292 4.7377 12.0667 4.7252 12 4.7252C11.9333 4.7252 11.8708 4.7377 11.8125 4.7627C11.7542 4.7877 11.7 4.8252 11.65 4.8752ZM12 13.0002C11.45 13.0002 10.9792 12.8044 10.5875 12.4127C10.1958 12.021 10 11.5502 10 11.0002C10 10.4502 10.1958 9.97936 10.5875 9.5877C10.9792 9.19603 11.45 9.0002 12 9.0002C12.55 9.0002 13.0208 9.19603 13.4125 9.5877C13.8042 9.97936 14 10.4502 14 11.0002C14 11.5502 13.8042 12.021 13.4125 12.4127C13.0208 12.8044 12.55 13.0002 12 13.0002ZM16.025 18.2502L18 19.0502V16.0752L16.825 15.2752C16.7417 15.7752 16.6292 16.2752 16.4875 16.7752C16.3458 17.2752 16.1917 17.7669 16.025 18.2502ZM12.775 2.6002C14.175 3.8002 15.2292 5.2752 15.9375 7.0252C16.6458 8.7752 17 10.7669 17 13.0002L19.1 14.4002C19.3833 14.5835 19.6042 14.8252 19.7625 15.1252C19.9208 15.4252 20 15.7419 20 16.0752V20.5252C20 20.8752 19.8542 21.1502 19.5625 21.3502C19.2708 21.5502 18.9583 21.5835 18.625 21.4502L15.025 20.0002H8.975L5.375 21.4502C5.04167 21.5835 4.72917 21.5502 4.4375 21.3502C4.14583 21.1502 4 20.8752 4 20.5252V16.0752C4 15.7419 4.07917 15.4252 4.2375 15.1252C4.39583 14.8252 4.61667 14.5835 4.9 14.4002L7 13.0002C7 10.7669 7.35417 8.7752 8.0625 7.0252C8.77083 5.2752 9.825 3.8002 11.225 2.6002C11.3417 2.51686 11.4667 2.4502 11.6 2.4002C11.7333 2.3502 11.8667 2.3252 12 2.3252C12.1333 2.3252 12.2667 2.3502 12.4 2.4002C12.5333 2.4502 12.6583 2.51686 12.775 2.6002Z"
                fill="#0088FF"
              />
            </svg>
            <span className="text-[#0088FF] text-base">Team</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Meet the{" "}
            <span className="bg-gradient-to-r from-[#0088FF] to-[#6583BA] bg-clip-text text-transparent font-hanken font-bold">
              Team
            </span>
          </h2>
          <p className="text-[#545454] max-w-4xl mx-auto mb-12 text-3xl">
            Get to know the people behind the platform—our team is a passionate
            group of builders, designers, and strategists committed to making
            supplier management smarter and more human.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              {
                name: "Alan Bray",
                job: "Founder/CEO",
                image: Alan,
              },
              {
                name: "Olena Danykh",
                job: "Tech Lead",
                image: Olena,
              },
              {
                name: "Bosun ",
                job: "Head of Design",
                image: Bosun,
              },
            ].map((member) => (
              <div
                key={member}
                className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition flex flex-col items-center"
              >
                <div className="w-28 h-28 rounded-full bg-[#EAF3FF] mb-4 flex items-center justify-center text-gray-400 text-xl">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover rounded-full"
                    />
                  ) : (
                    member.name.charAt(0)
                  )}
                </div>

                {/* Name */}
                <h4 className="font-semibold text-gray-900 text-lg">
                  {member.name}
                </h4>

                {/* Job Title */}
                <p className="text-gray-500 text-sm mt-1">{member.job}</p>
              </div>
            ))}
          </div>
        </section>

        {/* === CAREERS SECTION === */}
        <section
          ref={addToRefs}
          className="relative flex flex-col justify-center items-center w-full bg-bluegradient bg-no-repeat bg-cover bg-center px-6 md:px-16 lg:px-24 py-24 text-center"
        >
          <div className="inline-flex justify-start items-center gap-2 rounded-full px-4 py-2 w-fit mb-6 bg-[rgba(29,39,57,0.10)]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H1ZM7 18C6.71667 18 6.47917 17.9042 6.2875 17.7125C6.09583 17.5208 6 17.2833 6 17V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18H7ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V17C24 17.2833 23.9042 17.5208 23.7125 17.7125C23.5208 17.9042 23.2833 18 23 18H19.5ZM8.125 16H15.9C15.7333 15.6667 15.2708 15.375 14.5125 15.125C13.7542 14.875 12.9167 14.75 12 14.75C11.0833 14.75 10.2458 14.875 9.4875 15.125C8.72917 15.375 8.275 15.6667 8.125 16ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12ZM12 10C12.2833 10 12.5208 9.90417 12.7125 9.7125C12.9042 9.52083 13 9.28333 13 9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8C11.7167 8 11.4792 8.09583 11.2875 8.2875C11.0958 8.47917 11 8.71667 11 9C11 9.28333 11.0958 9.52083 11.2875 9.7125C11.4792 9.90417 11.7167 10 12 10Z"
                fill="#1D2739"
              />
            </svg>
            <span className="text-[#1D2739] text-base">Careers</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Join our <span className="text-[#0A66FF]">Team</span>
          </h2>
          <p className="text-[#1D2739] max-w-4xl mx-auto mb-12 text-3xl">
            Help us revolutionize supplier management with cutting-edge AI
            technology.
          </p>
          <button
            onClick={() =>
              window.open(
                "https://wellfound.com/company/sourceiqtalkdei/jobs",
                "_blank"
              )
            }
            className="bg-white text-black px-4 py-4 text-base font-medium rounded-lg transition mb-12 flex flex-row justify-center items-center gap-2"
          >
            View All Positions
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
            >
              <path d="M12 7L0 14L6.05683e-07 0L12 7Z" fill="black" />
            </svg>
          </button>

          {/* Positions */}
          <div className="flex flex-col sm:flex-row gap-8 p-4 sm:p-6">
            {openPositions.map((position, id) => (
              <div className="bg-white border w-full sm:w-[550px] border-gray-200 rounded-2xl p-4 sm:p-6 shadow-sm hover:shadow-md transition">
                <div className="flex items-center justify-between">
                  <div className="flex flex-col gap-2">
                    <h4 className="font-semibold text-base text-left text-gray-900">
                      {position.title}
                    </h4>

                    <div className="inline-flex items-center border border-[#1D2739] rounded-full px-4 py-1 text-[#1D2739] text-base w-fit">
                      {position.department}
                    </div>
                  </div>

                  <button
                    onClick={() => window.open(position.link, "_blank")}
                    className="border flex items-center gap-2 text-black px-5 py-2 rounded-lg hover:bg-[#EAF3FF] transition flex-shrink-0"
                  >
                    Apply
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="14"
                      viewBox="0 0 12 14"
                      fill="none"
                    >
                      <path d="M12 7L0 14L6.05683e-07 0L12 7Z" fill="black" />
                    </svg>
                  </button>
                </div>

                {/* Bottom row: location + tag */}
                <div className="flex flex-col sm:flex-row items-center gap-3 mt-4 md:mt-6">
                  <p className="text-base text-[#545454] flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 22C10.2333 22 8.79167 21.7208 7.675 21.1625C6.55833 20.6042 6 19.8833 6 19C6 18.6833 6.07083 18.3917 6.2125 18.125C6.35417 17.8583 6.56667 17.6083 6.85 17.375C7.08333 17.2083 7.3375 17.1417 7.6125 17.175C7.8875 17.2083 8.10833 17.3417 8.275 17.575C8.44167 17.8083 8.50417 18.0625 8.4625 18.3375C8.42083 18.6125 8.28333 18.8333 8.05 19C8.26667 19.2667 8.76667 19.5 9.55 19.7C10.3333 19.9 11.15 20 12 20C12.85 20 13.6667 19.9 14.45 19.7C15.2333 19.5 15.7333 19.2667 15.95 19C15.7167 18.8333 15.5792 18.6125 15.5375 18.3375C15.4958 18.0625 15.5583 17.8083 15.725 17.575C15.8917 17.3417 16.1125 17.2083 16.3875 17.175C16.6625 17.1417 16.9167 17.2083 17.15 17.375C17.4333 17.6083 17.6458 17.8583 17.7875 18.125C17.9292 18.3917 18 18.6833 18 19C18 19.8833 17.4417 20.6042 16.325 21.1625C15.2083 21.7208 13.7667 22 12 22ZM12.025 16.5C13.675 15.2833 14.9167 14.0625 15.75 12.8375C16.5833 11.6125 17 10.3833 17 9.15C17 7.45 16.4583 6.16667 15.375 5.3C14.2917 4.43333 13.1667 4 12 4C10.8333 4 9.70833 4.43333 8.625 5.3C7.54167 6.16667 7 7.45 7 9.15C7 10.2667 7.40833 11.4292 8.225 12.6375C9.04167 13.8458 10.3083 15.1333 12.025 16.5ZM12 18.525C11.8 18.525 11.6 18.4917 11.4 18.425C11.2 18.3583 11.0167 18.2583 10.85 18.125C8.88333 16.5583 7.41667 15.0292 6.45 13.5375C5.48333 12.0458 5 10.5833 5 9.15C5 7.96667 5.2125 6.92917 5.6375 6.0375C6.0625 5.14583 6.60833 4.4 7.275 3.8C7.94167 3.2 8.69167 2.75 9.525 2.45C10.3583 2.15 11.1833 2 12 2C12.8167 2 13.6417 2.15 14.475 2.45C15.3083 2.75 16.0583 3.2 16.725 3.8C17.3917 4.4 17.9375 5.14583 18.3625 6.0375C18.7875 6.92917 19 7.96667 19 9.15C19 10.5833 18.5167 12.0458 17.55 13.5375C16.5833 15.0292 15.1167 16.5583 13.15 18.125C12.9833 18.2583 12.8 18.3583 12.6 18.425C12.4 18.4917 12.2 18.525 12 18.525ZM12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11Z"
                        fill="#545454"
                      />
                    </svg>
                    {position.location}
                  </p>

                  <span className="text-sm text-white bg-[#0088FF] px-3 py-1 rounded-full">
                    Full-time
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Contact section */}
          <div className="flex flex-col justify-center items-center mt-16 bg-white/10 backdrop-blur-md border border-white/40 rounded-2xl p-8 max-w-3xl mx-auto shadow-lg">
            <span className="text-2xl font-bold mb-4">
              Don’t see a perfect fit?
            </span>
            <p className="text-[#1D2739] mb-4 text-base mt-4">
              We’re always looking for talented individuals who share our
              passion for innovation. Send us your resume and let’s talk about
              how you can contribute to our mission.
            </p>
            <a
              href="mailto:Info@sourceiq.cloud"
              className="bg-white text-black px-4 py-4 text-base mt-2 font-medium rounded-lg transition mb-6 flex flex-row justify-center items-center gap-2 hover:bg-gray-100"
            >
              Contact Us
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
              >
                <path d="M12 7L0 14L6.05683e-07 0L12 7Z" fill="black" />
              </svg>
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
